<template>
  <main class="main">
    <ui-sidebar />

    <div class="group group--sidebar f2f">
      <module-questionnaire
        intake-id="f2f"
        next-route-prefix="face2face"
        :on-complete-route="onCompleteRoute"
        :loading="loadingSingleQuestion"
      />

      <!-- <img class="f2f__image" :src="image" alt=""> -->
    </div>

    <div class="group group--df-column hide-above-large hide-below-medium mt-auto mb2">
      <p class="c-accent mw300 fs-14">Face to face requests take up to 10 business days for a response. Dont want to wait that long?</p>
      <router-link class="c-accent mw300 fs-14" :to="{ name: `results`}">Schedule a telehelath appointment today</router-link>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Components
import ModuleQuestionnaire from 'components/Questionnaire';
import UiSidebar from 'components/Sidebar';

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

import f2f from 'images/intake/f2f-characters.png';

const images = {
  f2f,
};

// Export
export default {
  name: 'view-support',

  components: {
    ModuleQuestionnaire,
    UiSidebar,
  },

  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  data() {
    return {
      image: images.f2f,
    };
  },

  // Computed
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('questions', ['loadingSingleQuestion']),

    onCompleteRoute() {
      return this.isAuthenticated ? 'confirm' : 'register';
    },
  },

  // Methods
  methods: {
    ...mapActions('app', ['setConfirmMessage', 'setConfirmDescription', 'setConfirmButton']),
  },

  // Lifecycles
  created() {
    if ( !this.isAuthenticated ) this.checkIntakeRequirements('default', null, null, 'support');

    if ( !localStorage.getItem('f2fselected') ) {
      this.$router.push({
        name: 'appointment-type',
      });
    }

    if ( this.isAuthenticated ) {
      this.setConfirmMessage('Would you like to submit your request for an in person appointment to our team now?');
      this.setConfirmDescription('A member of our team will call you within 1-2 days.');
      this.setConfirmButton({
        label: 'Continue',
        action: 'appointment/requestScheduleAppointment',
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Face2face.vue?7692c538